<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-body">
        <h5 class="text-center">LISTA DE PERSONAS</h5>{{ registrosFrontera.nombre }} 
        <div class="row">
          <div class="col-4">
            <label>BUSCAR:</label>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                v-model="buscar"
                placeholder="Buscar por Nombre o Nro Documento..."
              />
              <div class="input-group-append">
                <button
                  class="btn btn-info"
                  type="button"
                  @click="buscarPersona()"
                  :disabled="buscar == ''"
                >
                  <i class="fa fa-search"></i></button
                >&nbsp;
                <button
                  class="btn btn-secondary"
                  type="button"
                  @click="listarDatos()"
                >
                  <i class="fa fa-refresh"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          class="table-responsive mt-3"
          style="overflow-y:scroll; height:560px;"
        >
          <table class="table table-striped table-bordered">
            <thead>
              <tr class="text-center">
                <th><small class="font-weight-bold">#</small></th>
                <th><small class="font-weight-bold">NOMBRE COMPLETO</small></th>
                <th><small class="font-weight-bold">NRO. DOCUMENTO</small></th>             
                <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                <th><small class="font-weight-bold">FECHA REGISTRO</small></th>
                <th><small class="font-weight-bold">ACCIONES</small></th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(item, index) in registros" :key="index">
                <td class="text-center">
                  <small>{{ index + 1 }}</small>
                </td>
                <td>
                  <small>{{
                    item.per_nombres +
                      " " +
                      item.per_primer_apellido +
                      " " +
                      item.per_segundo_apellido
                  }}</small>
                </td>
                <td>
                  <small
                    >{{ item.per_numero_documento }} <br />
                    <span class="font-size-10">{{ item.tipo_documento }}</span>
                  </small>
                </td>               
                <td>
                  <small>{{ item.nacionalidad }}</small>
                </td>
                <td>
                  <small>{{ item.fecha_reg }}</small>
                </td>
                <td v-if="!item.multa" class="text-center">
                  <a
                    v-if="
                      $store.state.usuarioDB.id_rol != 5 &&
                        $store.state.usuarioDB.id_rol != 8
                    "
                    class="btn btn-outline-warning btn-sm mr-1"
                    title="Editar Registro"
                    @click="showModal(item)"
                  >
                    <i class="fa fa-edit"></i>
                  </a>

                  <a
                    v-if="
                      $store.state.usuarioDB.id_rol == 5
                    "
                    class="btn btn-outline-success btn-sm mr-1"
                    title="Reingreso"
                    @click="showModalReingreso(item)"
                  >
                    <i class="fa fa-refresh"></i>
                  </a>
                  
                  <router-link
                    v-if="
                      $store.state.usuarioDB.id_rol == 5 ||
                        $store.state.usuarioDB.id_rol == 2
                    "
                    :to="{
                      name: 'revisarSancion',
                      params: { id: item.id_persona },
                    }"
                    class="btn btn-outline-secondary btn-sm mr-1"
                    title="Realizar/Revisar Declaraciones"
                  >
                    <i class="fa fa-search"></i>
                  </router-link>
                  
                  <router-link
                    v-if="$store.state.usuarioDB.id_rol == 8"
                    :to="{
                      name: 'RevisarSancionDistrital',
                      params: { id: item.id_persona },
                    }"
                    class="btn btn-outline-secondary btn-sm mr-1"
                    title="Realizar/Revisar Declaraciones"
                  >
                    <i class="fa fa-search"></i>
                  </router-link>
                  
                  <!-- <a
                    class="btn btn-outline-info btn-sm mr-2"
                    title="Descargar"
                    
                    @click="getPdf()"
                  > -->
                  
                  <div>
                    <b-dropdown  variant="outline-primary fa fa-print" class="m-1 ">
                    
                      <b-dropdown-item :href="url">Español</b-dropdown-item>
                      <b-dropdown-item :href="url_ingles">Inglés</b-dropdown-item>
                    </b-dropdown>
                    
                  </div>
                  <a v-if="$store.state.usuarioDB.id_rol == 2" class="btn btn-outline-secondary " title="Eliminar" @click="bajaExtranjeroDuplicado(item)"><i class="fa fa-trash"></i> </a>
                  <!-- <a
                    class="btn btn-outline-info btn-sm mr-2"
                    title="Descargar"
                    :href="url"
                  >
                    <i class="fa fa-print"></i>
                  </a> -->                  
                </td>
                <td v-else>
                  <p class="text-danger text-center">SANCIONADO</p>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center" v-if="valida_mensajes==true"><h6><b>NO PRESENTA DECLARACIÓN</b></h6></div>
        </div>
      </div>
    </div>

    <b-modal
      class="modal fade"
      title="EDITAR PERSONA"
      size="lg"
      hide-footer
      ref="modalEditar"
      :no-close-on-backdrop="true"
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-12">
            <div class="form-group">
              <label
                >Nombres:
                <span
                  class="text-danger lb-error"
                  v-if="!$v.elegido.per_nombres.required"
                  >* Campo requerido</span
                ></label
              >
              <span
                class="text-danger lb-error"
                v-if="!$v.elegido.per_nombres.letras"
                >Solo debe ingresar letras</span
              >
              <input
                type="text"
                placeholder="Nombres..."
                class="form-control"
                :class="{
                  'is-invalid': $v.elegido.per_nombres.$error,
                }"
                v-model.trim="elegido.per_nombres"
                @keyup="elegido.per_nombres = elegido.per_nombres.toUpperCase()"
              />
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12">
            <div class="form-group">
              <label
                >Primer Apellido:
                <span
                  class="text-danger lb-error"
                  v-if="!$v.elegido.per_primer_apellido.required"
                  >* Campo requerido
                </span></label
              >
              <span
                class="text-danger lb-error"
                v-if="!$v.elegido.per_primer_apellido.letras"
                >Solo debe ingresar letras</span
              >
              <input
                type="text"
                placeholder="Primer Apellido..."
                class="form-control"
                :class="{
                  'is-invalid': $v.elegido.per_primer_apellido.$error,
                }"
                v-model.trim="elegido.per_primer_apellido"
                @keyup="
                  elegido.per_primer_apellido = elegido.per_primer_apellido.toUpperCase()
                "
              />
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12">
            <div class="form-group">
              <label>Segundo Apellido:</label>
              <span
                class="text-danger lb-error"
                v-if="!$v.elegido.per_segundo_apellido.letras"
                >Solo debe ingresar letras</span
              >
              <input
                type="text"
                placeholder="Segundo Apellido..."
                class="form-control"
                v-model.trim="elegido.per_segundo_apellido"
                @keyup="
                  elegido.per_segundo_apellido = elegido.per_segundo_apellido.toUpperCase()
                "
              />
            </div>
          </div>

          <div class="col-lg-4 col-md-4 col-sm-12">
            <div class="form-group">
              <label class=" mr-1">Tipo Documento:</label>
              <select
                class="custom-select"
                :class="{
                  'is-invalid': $v.elegido.par_tipo_documento.$error,
                }"
                v-model="elegido.par_tipo_documento"
              >
                <option
                  v-for="(item, index) in tipoDocumentos"
                  :value="item.codigo"
                  :key="index"
                  >{{ item.nombre }}</option
                >
              </select>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12">
            <div class="form-group">
              <label>
                Nro. Documento:
                <span
                  class="text-danger lb-error"
                  v-if="!$v.elegido.per_numero_documento.required"
                  >* Campo requerido</span
                >
              </label>
              <input
                type="text"
                placeholder="Nro Documento..."
                class="form-control"
                :class="{
                  'is-invalid': $v.elegido.per_numero_documento.$error,
                }"
                v-model.trim="elegido.per_numero_documento"
                @keyup="
                  elegido.per_numero_documento = elegido.per_numero_documento.toUpperCase()
                "
              />
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12">
            <div class="form-group">
              <label>
                Fecha Nacimiento:
                <span
                  class="text-danger lb-error"
                  v-if="!$v.elegido.per_fecha_nacimiento.required"
                  >* Campo requerido</span
                >
              </label>
              <input
                type="date"
                class="form form-control"
                :max="fechaMin"
                :class="{
                  'is-invalid': $v.elegido.per_fecha_nacimiento.$error,
                }"
                v-model="elegido.per_fecha_nacimiento"
              />
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12">
            <div class="form-group">
              <label
                >Género:
                <span
                  class="text-danger lb-error"
                  v-if="!$v.elegido.par_genero.required"
                  >Campo requerido</span
                >
              </label>
              <select
                class="custom-select"
                :class="{ 'is-invalid': $v.elegido.par_genero.$error }"
                v-model="elegido.par_genero"
              >
                <option value="">SELECCIONAR</option>
                <option value="F">FEMENINO</option>
                <option value="M">MASCULINO</option>
              </select>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12">
            <div class="form-group">
              <label>Telefono:</label>
              <span
                class="text-danger lb-error"
                v-if="!$v.elegido.per_telefono.numero"
                >Solo debe ingresar Numeros</span
              >
              <input
                type="number"
                placeholder="ej: 2521585"
                class="form-control"
                v-model.trim="elegido.per_telefono"
                @keyup="elegido.per_telefono = elegido.per_telefono"
              />
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12">
            <div class="form-group">
              <label>
                Nacionalidad:
                <span
                  class="text-danger lb-error"
                  v-if="!$v.elegido.par_nacionalidad.required"
                  >Campo requerido</span
                >
              </label>
              <select
                class="form form-control"
                :class="{ 'is-invalid': $v.elegido.par_nacionalidad.$error }"
                v-model="elegido.par_nacionalidad"
              >
                <option
                  v-for="(item, index) in nacionalidades"
                  :key="index"
                  :value="item.a3_dgm"
                  >{{ item.nombre }}</option
                >
              </select>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12">
            <div class="form-group">
              <label>Correo Electrónico:</label>
              <input
                type="email"
                placeholder="Email..."
                class="form form-control"
                :class="{ 'is-invalid': $v.elegido.per_email.$error }"
                v-model.trim="elegido.per_email"
              />
            </div>
          </div>
          <div class="col-lg-8 col-md-8 col-sm-12">
            <div class="form-group">
              <label>Desea modificar la contraseña y el usuario a <b>Nro. Documento:</b></label>
              <div></div>
                <input type="checkbox" id="checkbox" v-model="valida">
                <label for="checkbox"> <p v-if="valida==true">Se modificará usuario y contraseña</p><p v-else>Se mantendrá usuario y contraseña</p></label>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-4"></div>
          <div class="col-md-4">
            <a
              @click="hideModal"
              type="button"
              class="btn btn-secondary btn-block"
              ><small>Cancelar</small></a
            >
          </div>
          <div class="col-md-4">
            <a @click="editar" type="button" class="btn btn-primary btn-block"
              ><small>Modificar</small></a
            >
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      class="modal fade"
      title="REINGRESO"
      size="xl"
      hide-footer
      ref="modalReingreso"
      :no-close-on-backdrop="true"
    >
      <div class="container">
        <div class="row">
          <div class="col-6">
            <table class="table table-sm table-bordered table-condensed">
              <tr>
                <th>Nombre Completo:</th>
                <td>
                  {{ elegido_reing.per_nombres + " "
                  }}{{ elegido_reing.per_primer_apellido + " "
                  }}{{ elegido_reing.per_segundo_apellido }}
                </td>
              </tr>
              <tr>
                <th>Nro. Documento:</th>
                <td>
                  {{ datos_item.per_numero_documento }} <br />
                  {{ datos_item.par_tipo_documento }}
                </td>
              </tr>
            </table>
          </div>
          <div class="col-6">
            <div class="form-group">
              <div class="col-6">
                <label class=" mr-1">Documento con la que Reingresa</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="nro_documento_nuevo"
                  placeholder="123456"
                  @keyup="
                    nro_documento_nuevo = nro_documento_nuevo.toUpperCase()
                  "
                />
              </div>
              <div class="col-12 col-md-7">
                <label>Tipo Documento: </label>
                <select
                  class="form-control"
                  v-model="tipo_documento_nuevo"
                  
                >
                  <option value="">SELECCIONAR</option>
                  <option
                    v-for="(item, index) in tipoDocumentos"
                    :value="item.codigo"
                    :key="index"
                    >{{ item.nombre }}</option
                  >
                </select>
              </div>
            </div>
            <hr />
          </div>
        </div>

        <div class="row">
          <div class="col-md-6"></div>

          <div class="col-md-6 float-right">
            <a @click="hideModalReingreso" class="btn btn-secondary mr-4"
              >Cerrar</a
            >
            <!-- <button
              @click="registrarMulta(elegido.id_persona)"
              :disabled="elegido.fecha_deposito == undefined"
              class="btn btn-danger"
            >
              APLICAR SANCIÓN
            </button>-->
            <a v-if="nro_documento_nuevo != '' && tipo_documento_nuevo != ''"
              @click="RegistrarReingresoDomicilio(elegido_reing)"
              :href="url"
              class="btn btn-danger"
              
            >
              REINGRESO
            </a>
          </div>
        </div>
      </div>
    </b-modal>

    <Loading v-show="cargando" />
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import { required, email, minLength, helpers } from "vuelidate/lib/validators";
import moment from "moment";

const letras = helpers.regex("alpha", /^[a-zA-Z ]*$/);
const numero = helpers.regex("alpha", /^[-1234567890]*$/);

export default {
  components: {
    Loading,
  },
  data() {
    return {
      valida:false,
      usr_password: "",
      usr_usuario: "",
      per_nombres_ingreso: "",
      datos_item:[],
       nro_documento_nuevo:"",
        tipo_documento_nuevo:"",
      elegido_reing: {
       
        per_nombres: "",
        per_primer_apellido: "",
        per_segundo_apellido: "",
        per_numero_documento: "",
        par_tipo_documento: "",
        nacionalidad: "",
        lugar_ingreso: "",
      },

      observado: true,
      totalpagar: 100,
      valor_multa_bs: "",
      valor_multa_ufv: 100,
      registros: [],
      registrosFrontera: [],
      registros_persona: [],
      registros_reingreso: [],
      resultados: [],
      tipoDocumentos: [],
      nacionalidades: [],
      options: [],
      valida_mensajes:false,
      elegido: {
        id_persona: 0,
        per_nombres_elegidos: "",
        per_primer_apellido: "",
        per_segundo_apellido: "",
        par_tipo_documento: "",
        per_numero_documento: "",
        per_fecha_nacimiento: "",
        par_genero: "",
        par_nacionalidad: "",
        per_telefono: "",
        //par_nacionalidad: '',
      },
      buscar: "",
      url: process.env.VUE_APP_URL + "/documento/1",
      url_ingles: process.env.VUE_APP_URL + "/documento/4",
      filtro: "1",
      cargando: false,
      fechaMin: new moment().format("YYYY-MM-DD"),
    };
  },
  methods: {
    showModalReingreso(item) {
      this.elegido_reing = item;
      this.datos_item=item;
      this.$refs["modalReingreso"].show();
    },
    hideModalReingreso() {
      this.$refs["modalReingreso"].hide();
    },
    async RegistrarReingresoDomicilio() {
      let data = {
        id_persona: this.elegido_reing.id_persona,
        nro_documento_nuevo: this.nro_documento_nuevo,
        tipo_documento_nuevo: this.tipo_documento_nuevo,
      };
      try {
        this.resultados = await this.axios.post(`/domicilioOperadorReingreso`, data);
        this.actuaPersonas = this.resultados.data.contenido;
        this.hideModalReingreso();
        this.$swal({
          title: "<strong>REINGRESO Registrada</strong>",
          type: "success",
          html: `El reingreso fue registrada`,
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonAriaLabel: "Entendido!",
        });
        this.listarDatos();
        this.ActualizaUsuario();
        this.limpiar();
      } catch (error) {
        console.log(error);
      }
    },
    async ActualizaUsuario() {
      let data = {
        id_persona: this.elegido_reing.id_persona,
        usr_usuario: this.elegido_reing.per_numero_documento,
        usr_password: this.elegido_reing.per_numero_documento,
      };

      try {
        this.resultados = await this.axios.put(`/updateUsuarioReingreso`, data);
        this.actuaPersona = this.resultados.data.contenido;
      } catch (error) {
        console.log(error);
      }
    },
    filtrar() {
      if (this.filtro == "1") {
        this.listarDatos();
      } else if (this.filtro == "2") {
        this.listarSancionados();
      } else {
        this.listarNoSancionados();
      }
    },
    async buscarPersona() {
      // Busqueda general
      try {
        this.resultados = await this.axios.get(
          `/personas/buscar/${this.buscar}`
        );

        this.registros = this.resultados.data.contenido;
        if (this.registros.length==0) {
          this.valida_mensajes=true
        }

        if (this.registros[0].id_persona == null) {
          this.registros_persona = this.registros[0].id_persona;
          this.listarDatos();
        } else {
          this.registros = this.resultados.data.contenido;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async listarDatos() {
      try {
        this.cargando = true;
        let resultados = await this.axios.get(`/personas/extranjeros`);
        if (resultados.status == 200) {
          this.cargando = false;
          this.registros = resultados.data.contenido;
        }
      } catch (error) {
        this.cargando = false;
        console.log(error);
      }
    },
     async datosFrontera() {
      try {
        this.cargando = true;
        let resultados = await this.axios.get(`/lugar_frontera`);
        if (resultados.status == 200) {
          this.cargando = false;
          this.registrosFrontera = resultados.data.contenido;
        }
      } catch (error) {
        this.cargando = false;
        console.log(error);
      }
    },
    async listarSancionados() {
      try {
        this.resultados = await this.axios.get(`/sancionados`);
        this.registros = this.resultados.data.contenido;
      } catch (error) {
        console.log(error);
      }
    },
    async listarNoSancionados() {
      try {
        this.resultados = await this.axios.get(`/no_sancionados`);
        this.registros = this.resultados.data.contenido;
      } catch (error) {
        console.log(error);
      }
    },
    getDate: function(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    formatFecha(event) {
      let str = event;
      if (str != "" && str != null) {
        let arrayFecha = str.split("-");
        return arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
      } else {
        return "";
      }
    },
    showModal(item) {
      let indice = this.registros.indexOf(item);
      let data = this.registros[indice];
      this.elegido = data;

      this.$refs["modalEditar"].show();
    },
    hideModal() {
      this.$refs["modalEditar"].hide();
    },
    ofusca: function(cadena) {
      return window.btoa(cadena);
    },
    async getTipoDocumento() {
      try {
        let res = await this.axios.get(`/getParametros/DOCUMENTO`);
        this.tipoDocumentos = res.data.contenido;
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async limpiar() {
     this.nro_documento_nuevo='';
     this.tipo_documento_nuevo='';
    },
    async getNacionalidades() {
      let config = { headers: { token: this.token } };
      try {
        await this.axios
          .get(`/parametrosPaises`, config)
          .then((response) => {
            this.nacionalidades = response.data.contenido;
          })
          .catch((error) => {
            console.log("catch: ", error);
          });
      } catch (error) {
        console.log("catch: ", error);
      }
    },

    async editar() {
      this.cargando = true;
     
      this.$v.$touch();
      if(this.$v.elegido.$invalid){
        this.cargando = false;
        return;
      }
      let data = {
          elegido: this.elegido,
          valida: this.valida,
        };
          this.elegido=this.valida;
      try {
        let resultados = await this.axios.put(`/persona`, data);
        if (resultados.data.codigo == 1) {
          this.cargando = false;
          this.hideModal();
          this.$swal({
            title: "Información",
            type: "success",
            html: `Modificación correcta.`,
            showCloseButton: true,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonAriaLabel: "Entendido!",
          }).then((error) => {
            console.log("error: ", error);
            this.listarDatos();
          });

        }else if(resultados.data.codigo == 0){
               this.cargando = false;
          this.hideModal();
          this.$swal({
            title: "Información",
            type: "info",
            html: `Número de documento ya exite`,
            showCloseButton: true,
            showCancelButton: false,
            confirmButtonAriaLabel: "Entendido!",
          }).then((error) => {
            console.log("error: ", error);
            this.listarDatos();
          });
        }
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async bajaExtranjeroDuplicado(item)
    {
      //console.log('item',item);
      this.$swal({
        title: "Esta Seguro?",
        html: "De realizar la <b>baja</b> del registro.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Realizar Baja",
      }).then(async (result) => {
        if (result.value) {
          try {
            await this.axios.patch(`/persona/baja`, item);
            this.buscarPersona();
            this.$swal({
              title: "Información",
              text: "Se dio de Baja.",
              type: "success",
              confirmButtonText: "Aceptar",
            });
          } catch (error) {
            console.log(error);
          }
        }
      });      
    }
  },
  validations: {
    usuario: {
      direccion: { required, minLength: minLength(6) },
    },
    elegido: {
      per_nombres: { required, letras },
      per_primer_apellido: { required, letras },
      per_segundo_apellido: { letras },
      per_telefono: { numero },
      par_tipo_documento: { required },
      per_numero_documento: { required },
      per_fecha_nacimiento: { required },
      par_genero: { required },
      par_nacionalidad: { required },
      per_email: { email },
    },
  },
  created() {
    this.listarDatos();
   
    this.getTipoDocumento();
    this.getNacionalidades();
  },
};
</script>
